module.exports = __webpack_public_path__ + "img/金属材料学3_9.6eea8afe.png";